var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0 text-center py-12",attrs:{"fluid":""}},[_c('h1',[_vm._v("Page Not Found")]),_c('p',{staticClass:"subheading"},[_vm._v("The page you are looking for does not exist.")])])}
var staticRenderFns = []

export { render, staticRenderFns }